'use client'

import { Button } from '@populix/pop-ui'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

export default function ButtonCancelAccountDeletion() {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    setIsLoading(true)
    return router.push('/account-deletion/cancel')
  }

  return (
    <Button
      type='button'
      variant='contained'
      color='primary'
      onClick={handleClick}
      disabled={isLoading}
      aria-label='Cancel Account Deletion'
    >
      Cancel Account Deletion
    </Button>
  )
}
